module.exports = __webpack_public_path__ + "media/images/webpage/hotels/2669/plan2-1-f95ca64dcce1c1dd56ad08a93a80f157.webp";